import appContent from '@/services/content/appContent.typed';

import AutoDeliveryDcxInactiveBannerWidget from './components/AutoDeliveryDcxInactiveBannerWidget';

interface AutoDeliveryDcxStatusCancelledProps {
    className?: string;
}

const AutoDeliveryDcxStatusCancelled = ({className}: AutoDeliveryDcxStatusCancelledProps) => {
    const {banner} = appContent.getAutoDeliveryContent()?.dashboardContent?.cancelledDeliveryOnboardingDashboard || {};

    return <AutoDeliveryDcxInactiveBannerWidget className={className} banner={banner} />;
};

export default AutoDeliveryDcxStatusCancelled;
